import { useMutation } from '@tanstack/react-query'
import { putAcceptQuote } from 'services/WalletsService'

export const usePutAcceptQuoteMutation = () => useMutation(putAcceptQuote)
